import Switch from "./switch.js";

export default Switch;
